import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExpandIcon(props: IconProps) {
    return <Icon {...props} iconKey={"expand"}/>
}
